/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_CreditInputs */

const vi_order_settlement_credit = /** @type {(inputs: Order_Settlement_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi nợ`)
};

/**

* @param {Order_Settlement_CreditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_credit = /** @type {((inputs?: Order_Settlement_CreditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_CreditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_credit(inputs)
});